import { LGraphNode, LiteGraph } from "litegraph.js";
import { setGlobalConfig } from "../GlobalConfig.js";

export class ColorNode extends LGraphNode {
  constructor() {
    super();
    this.title = "Color";

    this.properties = {
      color: this.getUrlParam("animationColour") || "#000000"
    };

    this.addWidget("text", "Hex", this.properties.color, (val) => {
      if (/^#[0-9a-fA-F]{3,8}$/.test(val)) {
        this.properties.color = val;
        this.updateUrlParam("animationColour", val);
        setGlobalConfig("brushColor", val);
      }
    });

    this.addOutput("Color", "string");

    this.size = [200, 130];
    this.mode = LiteGraph.ALWAYS;
    this.color = "#2a2a2a";
    this.bgcolor = "#333333";
  }

  getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  updateUrlParam() {}

  onExecute() {
    this.setOutputData(0, this.properties.color);
  }

  onDrawForeground(ctx) {
    const pad = 10;
    const h = 30;
    const y = this.size[1] - h - 10;
    const w = this.size[0] - pad * 2;

    // Swatch
    ctx.fillStyle = this.properties.color;
    ctx.fillRect(pad, y, w, h);
    ctx.strokeStyle = "rgba(255,255,255,0.2)";
    ctx.strokeRect(pad, y, w, h);
  }

  onMouseDown(e, pos) {
    const swatchY = this.size[1] - 40;
    if (pos[1] >= swatchY && pos[1] <= swatchY + 30) {
      const input = document.createElement("input");
      input.type = "color";
      input.value = this.properties.color;
      input.style.cssText = "position:fixed;left:-9999px;top:-9999px;";
      document.body.appendChild(input);

      input.addEventListener("input", (ev) => {
        this.properties.color = ev.target.value;
        if (this.widgets[0]) this.widgets[0].value = ev.target.value;
        this.updateUrlParam("animationColour", ev.target.value);
        setGlobalConfig("brushColor", ev.target.value);
        this.setDirtyCanvas(true);
      });

      input.addEventListener("change", () => {
        if (input.parentNode) document.body.removeChild(input);
      });

      input.addEventListener("blur", () => {
        setTimeout(() => {
          if (input.parentNode) document.body.removeChild(input);
        }, 200);
      });

      input.click();
      return true;
    }
  }
}

LiteGraph.registerNodeType("input/Color", ColorNode);
